export const GTAG_ACTIONS = {
    BUTTON_CLICK: 'buttonClick',
}

export const GTAG_CATEGORY = {
    USER_INTERACTION: 'userInteraction',
}

export default {
    mounted() {
        let user = this.$store.state.userInfo;
        if (user) {
            this.$gtag.set("user_properties", {
                userId: user.userId
            });
        }
    },
    methods: {
        track(action, category, label, value) {
            this.$gtag.event(action, {
                event_category: category,
                event_label: label,
                value: value
            });
        },
        trackUserProperty(key, value) {
            this.$gtag.set('user_properties', {
                [key]: value
            });
        },
        trackButtonClick(buttonName) {
            this.track(buttonName, GTAG_CATEGORY.USER_INTERACTION, buttonName, 1);
        }
    },
}